import styled from 'styled-components';
import { media } from 'styledComponents/utils';

export const CheckoutWrapper = styled.div`
  .width-container {
    &.small {
      ${media.desktop`
        max-width: 1200px;
      `}
    }
  }
  .page-content {
    ${media.desktop`
      flex-direction: row; align-items: flex-start;
    `}
  }
`;

export const OrderSummary = styled.div`
  background-color: white;
  margin-top: 20px;
  padding: 16px;
  width: 100%;
  max-width: 375px;
  box-shadow: 0 2px 4px rgba(51, 51, 51, 0.08);

  ${media.tablet`
    max-width: 568px;  
    padding: 20px;
  `}

  ${media.desktop`
    max-width: 375px;
    margin-top: 40px;
    padding: 40px;
  `}

  .page-content {
    &.promo-code {
      &.open {
        ${media.desktop`
          flex-wrap: wrap !important;
        `}
      }
    }
  }
  
  hr {
    &.light {
      background-color: #d9d9d9;
      margin: 10px 0;
    }
  }
`;

export const SubmitContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: white;
  z-index: 100;
  width: 100%;
  margin-top: 25px;
  .submit-button {
    width: 100%;
  }
  ${media.tablet`
    position: relative;
    border: none;
    padding-top: 20px;
  `}
`;

export const Button = styled.div`
  width: 100%;
  padding: 15px 25px;
  background-color: #000000;
  border-radius: 100px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const Sections = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  max-width: 568px;
  ${media.tablet`

  `}
  ${media.desktop`
    max-width: 800px;
    margin-left: 13%;
  `}
  .scroll-wrapper {
    margin: 0 auto;
    width: 100%;
    margin-top: 30px;
    ${media.tablet`
      max-width: 800px;
      margin-top: 20px;
    `}
    ${media.desktop`
      margin-right: 40px;
    `}
  }
`;

export const ProductWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  padding: 20px 0;
  border-bottom: 2px solid rgb(245, 243, 242);
  margin-bottom: 10px;
`;

export const ProductImage = styled.div`
  height: 66px;
  width: 57px;
  background-image: url(${props => props.src});
  background-size: cover;
`;

export const TextWrapper = styled.div`
  margin-left: 10px;
  h1 {
    margin: 0;
    line-height: 1;
    font-size: 16px;
    margin-bottom: 7px;
    margin-top: 2px;
  }
  h2 {
    margin: 0;
    margin-bottom: 7px;
    font-size: 14px;
    line-height: 1;
    &.size {
      color: rgb(139, 138, 135);
    }
  }
`;

export const Spacer = styled.div`
  height: 30px;
  ${media.tablet`
    height: 0;
  `}
`;
